// eslint-disable-next-line
export function setOriginSearch() {
  window.sessionStorage.setItem('origin-search', window.location.pathname);
}
